import { Box, useColorModeValue } from '@chakra-ui/react';
import { ReactComponent as FxIcon } from '../../../../core/assets/icons/fx.svg';

const FormulaIcon = () => {
  const borderColor = useColorModeValue('gray.200', 'gray.800');
  const iconFill = useColorModeValue('#000', '#fff');

  return (
    <Box
      width="40px"
      rounded="md"
      border="1px"
      borderColor={borderColor}
      mr={1}
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
      color="ButtonText"
      background="InfoBackground"
      boxShadow="sm"
    >
      <FxIcon height="17px" width="17px" fill={iconFill} />
    </Box>
  );
};

export default FormulaIcon;
